<template>
  <div class="body">
    <!-- <div class="timerBox">
      <img class="backIcon" src="@/assets/back_black.png" alt="" @click="toDoReview">
      <p>答题卡</p>
      <img class="backIcon" style="visibility: hidden;" src="@/assets/back_black.png">
    </div> -->
    <div class="main">
      <div v-show="doResult.list.length > 0" class="lists">
        <ul>
          <li v-for="(item, index) in doResult.list" :key="index" @click="clickItem(index,item)">
            <span v-if="item.bg_type" class="item_red">
              {{ index + 1 }}
            </span>
            <span v-else class="item_gray">{{ index + 1 }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="!isDoWrong()" class="footer">
      <span class="redBgBtn" @click="submitAllAlert">交卷并查看结果</span>
    </div>
  </div>
</template>

<script>
import { submitAnswer } from '@/api/zkbproEdu.js'
import { type } from 'os'
import { Dialog } from 'vant'

export default {
  props: {
    sonModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      time: this.$route.query.time || '0',
      lesson_id: this.$route.query.lesson_id || '',
      class_id: this.$route.query.class_id || '',
      schedule_id: this.$route.query.schedule_id,
      source_id: this.$route.query.source_id,
      source_type: this.$route.query.source_type,
      answer_id: '',
      answer: [],
      doResult: [],
      noDoCount: 0,
      // 传递用
      aQuery: {},
      // 做题页的index
      doIndex: 0,
      pageType: this.$route.query.pageType,
      tabswitch: this.$route.query.tabswitch,
      chat_id: this.$route.query.chat_id
    }
  },
  created() {
    console.log(this.sonModule)
    this.initQueryDatas()
    this.pageDatas()
  },
  methods: {
    // 处理传参
    initQueryDatas() {
      const query = this.$route.query
      this.doIndex = query.index || 0
      console.log(this.doIndex)
      const keys = Object.keys(query)
      const obj = {}
      keys.forEach(e => {
        if (e != 'time' && e != 'index' && e != 'result_id') {
          obj[e] = query[e]
        }
      })
      this.aQuery = obj
    },
    // 页面数据
    pageDatas() {
      const arr = []
      var noDoCount = 0
      this.doResult = JSON.parse(sessionStorage.getItem('paperLists'))
      console.log('this.doResult', this.doResult)
      this.answer_id = this.doResult.answer_id
      this.doResult.list.forEach(e => {
        e.select_status = e.select_status ? e.select_status : 1
        e.select_status = e.icant ? 2 : e.select_status
        if (this.doResult.answer_type == 1) {
          var str = ''
          if (e.userSelect) {
            const sel = e.userSelect
            if (typeof (sel) === 'string') {
              const selStr = sel.toString()
              if (selStr.indexOf(',' != -1)) {
                str = selStr
              } else {
                str = selStr.split('').join(',')
              }
            } else {
              str = sel.join(',')
            }
          } else {
            str = ''
          }
          if (e.select_status == 1) {
            noDoCount++
            e.bg_type = 0
          } else {
            e.bg_type = 1
          }
          // 新主观题答案处理
          const is_new = this.checkIsNewSubjective(e)
          if (e.exercise_type == 3 && is_new) {
            str = e.user_answer || ''
            e.select_status = e.icant ? 2 : e.select_status
          }
          const obj = {
            id: e.id,
            option: is_new ? [] : (str === '' ? [] : str.split(',')),
            select_status: e.select_status,
            user_answer: is_new ? str : '',
            is_new: is_new ? 1 : '',
            exercise_type: e.exercise_type
          }
          arr.push(obj)
        } else {
          var str = ''
          if (e.select_status > 1) {
            str = e.exercise_type == 2 ? e.select.join(',') : e.select.toString()
            e.bg_type = 1
          } else {
            noDoCount++
            e.bg_type = 0
          }
          // 新主观题答案处理
          const is_new = this.checkIsNewSubjective(e)
          if (e.exercise_type == 3 && is_new) {
            str = e.user_answer || ''
            e.select_status = e.icant ? 2 : e.select_status
          }
          const obj = {
            id: e.id,
            option: is_new ? [] : (str === '' ? [] : str.split(',')),
            select_status: e.select_status,
            user_answer: is_new ? str : '',
            is_new: is_new ? 1 : '',
            exercise_type: e.exercise_type
          }
          arr.push(obj)
        }
      })
      console.log('noDoCount = ', noDoCount)
      this.noDoCount = noDoCount
      this.answer = arr
    },
    // 判断是否是新主观题
    checkIsNewSubjective(val) {
      if (val.exercise_type == 3) {
        const answer_type = val.answer_type || ''
        if (answer_type && answer_type.length > 0 && answer_type != 0) {
          return true
        }
      }
      return false
    },
    clickItem(idx, obj) {
      console.log(idx)
      this.$emit('activePage', idx)
      // 整理参数
      // this.aQuery.page = idx
      // this.$router.replace({
      //   path: '/exerciseMode',
      //   query: this.aQuery
      // })
    },
    // 返回做题
    toDoReview() {
      const page = parseInt(this.doIndex)
      this.clickItem(page)
    },
    // 返回
    backAction() {
      if (!this.isDoWrong()) {
        // 不是错题
        Dialog.confirm({
          message: '确定要退出，并保存本次练习？'
        })
          .then(() => {
            // on confirm
            this.backFunction()
          })
          .catch(() => {
            // on cancel
          })
      } else {
        // 直接返回
        this.backFunction()
      }
    },
    // 返回的方法
    backFunction() {
      sessionStorage.removeItem('paperLists')
      this.$router.go(-1)
    },
    // 提交之前的弹窗
    submitAllAlert() {
      // let message = '本练习还有' + this.noDoCount + '道题未做，确认交卷么？'
      // this.$toast(message)
      if (this.noDoCount > 0) {
        const message = '本练习还有' + this.noDoCount + '道题未做，确认交卷么？'
        Dialog.confirm({
          message: message
        })
          .then(() => {
            // on confirm
            this.submitAll()
          })
          .catch(() => {
            // on cancel
          })
      } else {
        // 直接提交
        this.submitAll()
      }
    },
    // 提交
    submitAll() {
      this.$emit('clearTimer')
      const info1 = {
        answer_id: this.answer_id,
        spend: this.time,
        answer: JSON.stringify(this.answer),
        is_app: 0
      }
      console.log(info1)
      submitAnswer(info1).then(res => {
        console.log(res)
        const errNo = res.errNo
        if (errNo == 0) {
          sessionStorage.removeItem('paperLists')
          if (this.$route.query.pkType == 1) {
            var url = ''
            if (this.$route.query.pageType == 1) {
              url = `/pages/pkhome/pkhome?lesson_id=${this.lesson_id}`
            } else {
              url = `/pages/pklist/pklist?lesson_id=${this.lesson_id}&tabswitch=${this.$route.query.tabswitch}&chat_id=${this.$route.query.chat_id}`
            }
            this.$wx.miniProgram.redirectTo({
              url: url
            })
          } else {
            this.$router.replace({
              path: '/exerciseReport',
              query: {
                answer_id: this.answer_id,
                source_id: this.source_id,
                source_type: this.source_type,
                lesson_id: this.lesson_id,
                class_id: this.class_id,
                schedule_id: this.schedule_id,
                is_exercise_end: 1
              }
            })
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 判断是否是错题
    isDoWrong() {
      if (this.source_type == 5 || this.source_type == 6 || this.source_type == 7) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
$bottomH: 150px;

.body {
  text-align: left;
  width: 100%;
  background-color: #fff;
}
.topHead {
  position: relative;
}
.timerBox {
  padding: 0px 10px;
  background-color: #fff;
  width: calc(100% - 20px);
  height: 100px;
  border-bottom: 1px solid #eee;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  .backIcon {
    margin: auto 0;
    width: 68px;
    height: 68px;
  }
  p {
    flex: 1;
    margin: 10px 10px;
    font-family: PingFangSC-Regular;
    color: #333;
    font-size: 36px;
    text-align: center;
  }
  .counts {
    margin: auto 10px;
    color: #333;
    font-size: 32px;
  }
}

.footer {
  background-color: #fff;
  // border-top: 1px solid #ddd;
  width: 100%;
  height: $bottomH;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  .redBgBtn {
    width: 80%;
    height: 90px;
    display: inline-block;
    background-color: #ee2e2e;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 32px;
    color: #ffffff;
    font-weight: 400;
    text-align: center;
    line-height: 90px;
    border-radius: 50px;
  }
}

.main {
  height: calc(100vh - 500px);
  width: 100%;
  display: inline-block;
  // padding-top: 100px;
  padding-bottom: $bottomH;
  background-color: #fff;
  overflow-y: scroll;
  li {
    float: left;
    width: 20%;
    height: 132px;
    text-align: center;
  }
  span {
    margin-top: 30px;
    width: 72px;
    height: 72px;
    text-align: center;
    display: inline-block;
    border-radius: 36px;
    line-height: 72px;
    font-size: 36px;
    color: #fff;
  }
  .item_red {
    background-color: #ee2e2e;
  }
  .item_gray {
    // background-color: #d8d8d8;
    border:2px solid #ccc;
    color:#333;
  }
}
</style>
